import { render, staticRenderFns } from "./fzlc.vue?vue&type=template&id=5f8c0766&scoped=true&"
import script from "./fzlc.vue?vue&type=script&lang=js&"
export * from "./fzlc.vue?vue&type=script&lang=js&"
import style0 from "./fzlc.vue?vue&type=style&index=0&id=5f8c0766&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c0766",
  null
  
)

export default component.exports